import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./CreateTemplate.module.sass";
import Card from "../../../components/Card";
import Tooltip from "../../../components/Tooltip";
import TextInput from "../../../components/TextInput";
import nameAndDesc from "../NameAndDescription/NameAndDescription.module.sass";
import Icon from "../../../components/Icon";
import Dropdown from "../../../components/Dropdown";
import ImageInput from "../../../components/ImageInput";
import { InputController } from "../../../hooks/input-controller";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import Modal from "../../../components/Modal";
import Schedule from "../../../components/Schedule";

const optionsPurchase = ["SINGLE_EDITION", "LIMITED_EDITION", "OPEN_EDITION"];
const optionsCategory = ["Adventure", "Cemody", "Horror"];

const CreateTemplate = ({
	setReqBody,
	className,
	removeTemplate,
	_key,
	initialVal,
	TemplateModalOnClose,
}) => {
	const [local, setLocal] = useState({
		...initialVal,
	});
	const {
		onOpen: startOpen,
		onClose: startClose,
		isOpen: startIsOpen,
	} = UseDisclosure();
	const {
		onOpen: endOpen,
		onClose: endClose,
		isOpen: endIsOpen,
	} = UseDisclosure();
	const [purchase, setPurchase] = useState(initialVal.type);
	const name = InputController("name", setLocal);
	const price = InputController("price", setLocal);
	const description = InputController("description", setLocal);
	const totalNFTs = InputController("totalNFTs", setLocal);
	const [startDate, setStartDate] = useState(
		initialVal.startDate === "" ? "" : new Date(initialVal.startDate)
	);
	const [endDate, setEndDate] = useState(
		initialVal.endDate === "" ? "" : new Date(initialVal.endDate)
	);

	const HandleChange = (e) => {
		setLocal((p) => {
			return {
				...p,
				image: e,
			};
		});
	};

	useEffect(() => {
		setLocal((p) => {
			return {
				...p,
				type: purchase,
			};
		});
	}, [purchase]);

	useEffect(() => {
		setLocal((p) => {
			return {
				...p,
				endDate,
				startDate,
			};
		});
	}, [endDate, startDate]);

	const handleRemove = () => {
		removeTemplate(_key);
	};

	const addTemplate = () => {
		let key = _key;
		if (!_key) key = Date.now();
		setReqBody((p) => {
			return {
				...p,
				nftTemplates: { ...p.nftTemplates, [key.toString()]: local },
			};
		});
		TemplateModalOnClose();
	};

	// useEffect(() => {
	// 	setReqBody((p) => {
	// 		return {
	// 			...p,
	// 			nftTemplates: { ...p.nftTemplates, [_key]: local },
	// 		};
	// 	});
	// }, [local]);

	return (
		<Card
			className={cn(styles.card, className)}
			title="Product create"
			classTitle="title-green"
			head={
				<>
					{_key && (
						<>
							<button
								className={cn("button-stroke button-small", styles.button)}
								onClick={handleRemove}
							>
								<Icon name="trash" size="24" />
								<span>Delete</span>
							</button>
							<div className={styles.spacer} />
						</>
					)}
					<button
						className={cn("button button-small", styles.button)}
						onClick={addTemplate}
					>
						<span>{_key ? "Save" : "Confirm"}</span>
					</button>
				</>
			}
		>
			<div className={nameAndDesc.description}>
				<TextInput
					defaultValue={local.name}
					className={nameAndDesc.field}
					label="Title"
					name="title"
					type="text"
					tooltip="Title"
					required
					{...name}
				/>
				<Dropdown
					className={styles.field}
					label="Category"
					tooltip="Category"
					options={optionsCategory}
				/>
				<div style={{ marginTop: "32px" }}>
					<TextInput
						className={styles.editor}
						defaultValue={local.description}
						label="Description"
						name="description"
						type="text"
						textarea
						tooltip="Maximum 100 characters. No HTML or emoji allowed"
						required
						{...description}
					/>
				</div>
				<button className="button">Detailed description</button>
			</div>
			<div className={styles.price} style={{ marginTop: "32px" }}>
				<TextInput
					className={styles.field}
					defaultValue={local.price}
					label="Amount"
					name="amount"
					type="number"
					tooltip="Small description"
					required
					currency="$"
					{...price}
				/>
				<Dropdown
					className={styles.field}
					label="Type"
					tooltip="Type"
					value={purchase}
					setValue={setPurchase}
					options={optionsPurchase}
				/>
				<div style={{ marginTop: "32px" }}>
					<TextInput
						className={styles.field}
						classLabel={styles.label}
						defaultValue={local.totalNFTs}
						label="Total supply"
						tooltip="Total supply"
						type="number"
						required
						{...totalNFTs}
					/>
				</div>
				<div className={styles.price} style={{ marginTop: "32px" }}>
					<ImageInput
						where="TEMPLATES"
						callBack={HandleChange}
						className={styles.field}
						label="Image"
						tooltip="Image"
						initial={local.image}
					/>
				</div>
				<div className={styles.line} style={{ marginTop: "32px" }}>
					<div className={styles.info}>
						Purchase dates{" "}
						<Tooltip
							className={styles.tooltip}
							title="Purchase dates"
							icon="info"
							place="top"
						/>
					</div>
					{/* <Switch
            className={styles.switch}
            value={resolution}
            onChange={() => setResolution(!resolution)}
          /> */}
				</div>
				<div className={styles.fieldset}>
					<div className={cn(styles.field)} onClick={startOpen}>
						<TextInput
							classLabel={styles.label}
							label="Start date"
							name="Start date"
							type="text"
							required
							value={startDate.toLocaleString()}
							onChangeInput={() => {}}
						/>
					</div>
					<div className={styles.field} onClick={endOpen}>
						<TextInput
							classLabel={styles.label}
							label="End date"
							name="End date"
							type="text"
							required
							value={endDate.toLocaleString()}
							onChangeInput={() => {}}
						/>
					</div>
				</div>
			</div>
			<Modal visible={startIsOpen} onClose={startClose}>
				<Schedule
					onClick={startClose}
					startDate={startDate}
					setStartDate={setStartDate}
				/>
			</Modal>
			<Modal visible={endIsOpen} onClose={endClose}>
				<Schedule
					onClick={endClose}
					startDate={endDate}
					setStartDate={setEndDate}
				/>
			</Modal>
		</Card>
	);
};

export default CreateTemplate;
